import { useState, useEffect } from "react";
import MemosList from "./components/MemosList/MemosList";
import "./Memos.css";
import { useState } from "react";
import memoService from "./services/memoService.js";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import Dropdown from "/src/components/UI/DropDown/DropDown";
import useMemoCategories from "./hooks/useMemoCategories";
import InputSearch from "/src/components/UI/InputSearch/InputSearch";
import { MemoViewData } from "./data/MemoViewTypes";
import Tag from "/src/assets/img/svg/tag.svg";
import { setClassifictionMode, getAllParameters } from "./hooks/storageMemoHelper";
import storage from "/src/utils/storage";

function Memos() {
    const { getMemos } = memoService;

    const sortList = (data) => {
        return data.sort((a, b) => {
            return new Date(b.updated_at) - new Date(a.updated_at);
        });
    };

    const [data, setData] = useState([]);
    const { categories, addFirstRow } = useMemoCategories();

    const [memosPrinted, setMemosPrinted] = useState([]);
    const [classifiedMode, setClassifiedMode] = useState(getAllParameters() ? getAllParameters().isClassified : false); // true = Classified, false = Global

    const [filter, setFilter] = useState({ search: "", category: "" });

    const setUpData = async () => {
        const [response, errors] = await getMemos();
        if (errors != null) {
            console.log(errors);
            return;
        }
        setData(sortList(response));
        setData(response);
        setMemosPrinted(response);
    };

    const setUpMemosPrinted = () => {
        var res = data;
        if (filter.category != 0) {
            res = res.filter((memo) => memo.category.id == filter.category);
        }
        if (filter.search != "") {
            res = res.filter(
                (memo) =>
                    memo.name.toLowerCase().includes(filter.search) ||
                    memo.description.toLowerCase().includes(filter.search)
            );
        }
        setMemosPrinted([...res]);
    };

    useEffect(() => {
        if (data != null) {
            setUpData();
        }
    }, []);

    useEffect(() => {
        if (categories.length > 0 && categories[0].value != 0) {
            addFirstRow({
                value: 0,
                text: <span style={{ maxWidth: "200px" }}>All</span>,
            });
        }
    }, [categories]);

    const switchButton = () => {
        setClassifictionMode(!classifiedMode);
        setClassifiedMode(!classifiedMode);
    };

    const changeCategory = (value) => {
        setFilter({ ...filter, category: value });
    };

    const research = async (value) => {
        setFilter({ ...filter, search: value.toLowerCase() });
    };
    useEffect(() => {
        setUpMemosPrinted();
    }, [filter]);

    const getDataByViewType = (viewType) => {
        return memosPrinted.filter((memo) => memo.view.view == viewType);
    };

    return (
        <>
            <br />
            <br />
            <div className="memo_page_container">
                <div className="container_parameters_memo">
                    <div className="input_memo_search">
                        <InputSearch
                            placeholderLibelle="content"
                            onChange={(e) => research(e.target.value)}></InputSearch>
                    </div>

                    {Array.isArray(categories) && categories.length > 0 ? (
                        <Dropdown
                            className="dropdown_category_memo_search"
                            icon={Tag}
                            setValue={(name, value) => changeCategory(value)}
                            choices={categories}
                            width="200px"></Dropdown>
                    ) : null}

                    <IconButton
                        className="main-iconButton profil_action main_add-button space_tableButton memo_button_ordering"
                        title={"Switch to " + (classifiedMode ? "Global" : "Classified") + " mode"}
                        icon={classifiedMode ? "fas fa-list-alt" : "fas fa-sitemap"}
                        key={"buttonMemoGroup"}
                        onClick={() => switchButton()}
                    />
                </div>
                <br />
                <br />
                <br /> <br />
                <div>
                    {classifiedMode ? (
                        MemoViewData.map((type, index) => {
                            if (storage("local").get("user").is_admin == false && type.value == 1) return;
                            return (
                                <MemosList
                                    key={index}
                                    title={type.title + " section"}
                                    view={type.value}
                                    data={getDataByViewType(type.value)}
                                    postbackAction={setUpData}
                                />
                            );
                        })
                    ) : (
                        <MemosList title="Company Memos" data={memosPrinted} type="bots" postbackAction={setUpData} />
                    )}
                    <br />
                    <br />
                    <br /> <br />
                </div>
            </div>
        </>
    );
}

export default Memos;
